/** @format */

import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconBrandingDsgMono,
	homefieldIconChainLink,
	homefieldIconNikeLogo,
	homefieldIconNikeMember,
	homefieldIconNikeShoe,
	homefieldIconRewards
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-exclusive-product-overlay',
	templateUrl: './exclusive-product-overlay.component.html',
	styleUrl: './exclusive-product-overlay.component.scss',
	imports: [HomefieldIconLibraryModule]
})
export class ExclusiveProductOverlayComponent implements OnChanges {
	@Input()
	public shouldShowPanel = true;

	@Input()
	public brand: string;

	timeout = 2000;

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconNikeLogo,
			homefieldIconBrandingDsgMono,
			homefieldIconChainLink,
			homefieldIconNikeShoe,
			homefieldIconNikeMember,
			homefieldIconRewards
		]);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.shouldShowPanel && this.shouldShowPanel) {
			setTimeout(() => {
				const overlay = document.getElementById('nike-connected-overlay');
				if (overlay) {
					overlay.classList.add('invisible');
				}
			}, this.timeout);
		}
	}
}
